import type { Nullable } from '../../../types';
import type { ILegalNotice } from './iLegalNotice';

export default class LegalNotice implements ILegalNotice {
  identifier: string;

  version: Nullable<number>;

  constructor(identifier: string, version: Nullable<number> = null) {
    this.identifier = identifier;
    this.version = version;
  }

  toRequestData(): {
    identifier: string;
    version: Nullable<number>;
  } {
    return {
      identifier: this.identifier,
      version: this.version,
    };
  }

  static privacyPolicy(): LegalNotice {
    return new LegalNotice('privacy_policy');
  }
}
